module.exports = __webpack_public_path__ + "static/media/double vision.75aef0da.png";